import React from 'react'
import { Link } from 'react-router-dom'
import { Heading, Skeleton, Text } from '@liquidcollectibles/uikit'
import styled from 'styled-components'
import { NftCollectionApr } from 'state/collectibles/types'
import NfaPreview from 'components/NftCard/_components/NfaPreview'
import tokens from 'config/constants/tokens'
import Preview from './Preview'

const AuthorTag = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-radius: 24px;
`

const AuthorLogo = styled.div<{ backgroundImage?: string }>`
  height: 19px;
  width: 19px;
  margin-right: 6px;
  background-image: url('${(props) => props.backgroundImage || licoTokenImg}');
  background-size: cover;
  background-position: center;
`

const SkeletonImg = styled.div`
  position: relative;
  border-radius: 6px 0px 0px 6px;
  max-width: 160px;
  overflow: hidden;
  min-height: 160px;
`

const Container = styled(Link)`
  display: flex;
  border: 1px solid #424242;
  background: #212121;
  border-radius: 6px;

  ${({ theme }) => theme.mediaQueries.lg} {
    flex-direction: column;
  }

  ${({ theme }) => theme.mediaQueries.xl} {
    flex-direction: row;
  }
`

const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 8px;
  color: white;

  ${({ theme }) => theme.mediaQueries.sm} {
    padding: 16px;
  }
`

const licoAuthor = 'Liquid Collectibles'
const licoTokenImg = '/images/lico-token.svg'
const licoStakeImg = '/images/home/hot-section/lico-stake.png'

const StackingCard = ({ collection }: { collection: NftCollectionApr }) => {
  const ImgPreview =
    collection.nftAddress === '0x6afc012783e3a6ef8c5f05f8eee2edef6a052ec4' ? (
      <NfaPreview src={collection.previewImage} alt={collection.name} />
    ) : (
      <Preview
        src={collection.nftAddress ? collection.previewImage : licoStakeImg}
        alt={collection.nftAddress ? collection.name : tokens.lico.symbol}
      />
    )

  return (
    <Container to={`/stake#${collection.symbol ?? tokens.lico.symbol}`}>
      {!collection.apr ? (
        <SkeletonImg>
          <Skeleton width="600px" height="100%" />
        </SkeletonImg>
      ) : (
        <>{ImgPreview}</>
      )}

      <InfoContainer>
        {!collection.apr ? (
          <Skeleton />
        ) : (
          <AuthorTag>
            <AuthorLogo
              backgroundImage={
                !collection.category || collection.category === 'Original'
                  ? licoTokenImg
                  : `/images/tokens/${collection.vaultTokenAddress}.png`
              }
            />
            <Text bold>{collection.author ?? licoAuthor}</Text>
          </AuthorTag>
        )}

        <div>
          {!collection.apr ? <Skeleton width="30%" /> : <Text fontSize="12px">APY</Text>}
          {!collection.apr ? (
            <Skeleton width="70%" />
          ) : (
            <Heading scale="xl">{`${collection.apr?.toFixed(2)}%`}</Heading>
          )}
        </div>

        {!collection.apr ? (
          <Skeleton />
        ) : (
          <Text fontSize="12px" style={{ whiteSpace: 'nowrap' }}>{`Deposit ${tokens.lico.symbol} and earn ${
            collection.symbol ?? tokens.lico.symbol
          }`}</Text>
        )}
      </InfoContainer>
    </Container>
  )
}

export default StackingCard
